// Copyright (c) 2025 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Container, Header, Icon, Breadcrumb } from 'semantic-ui-react';
import PolicyTypeConfigSection from '../components/PolicyTypeConfigSection';
import { brokerageApi } from '../api/brokerageApi';
import { providerApi } from '../api/providerApi';

function BrokerageProviderPolicyTypesPage() {
  const navigate = useNavigate();
  const { brokerageId, providerId } = useParams<{ brokerageId: string; providerId: string }>();

  const [brokerageName, setBrokerageName] = useState<string>('');
  const [providerName, setProviderName] = useState<string>('');

  useEffect(() => {
    const loadNames = async () => {
      try {
        if (brokerageId) {
          const brokerage = await brokerageApi.getById(brokerageId);
          setBrokerageName(brokerage.name);
        }
        if (providerId) {
          const provider = await providerApi.getById(providerId);
          setProviderName(provider.name);
        }
      } catch (err) {
        console.error('Failed to load names for breadcrumbs:', err);
      }
    };
    loadNames();
  }, [brokerageId, providerId]);

  return (
    <Container style={{ padding: '2rem' }}>
      <Breadcrumb>
        <Breadcrumb.Section link onClick={() => navigate('/brokerages')}>
          Brokerages
        </Breadcrumb.Section>
        <Breadcrumb.Divider />
        <Breadcrumb.Section link onClick={() => navigate(`/brokerages/${brokerageId}/providers`)}>
          {brokerageName || 'Brokerage'}
        </Breadcrumb.Section>
        <Breadcrumb.Divider />
        <Breadcrumb.Section link onClick={() => navigate(`/brokerages/${brokerageId}/providers/${providerId}/edit`)}>
          {providerName || 'Provider'}
        </Breadcrumb.Section>
        <Breadcrumb.Divider />
        <Breadcrumb.Section active>
          Policy Types
        </Breadcrumb.Section>
      </Breadcrumb>

      <Header as='h1' style={{ marginTop: '1rem' }}>
        <Icon name='file alternate' />
        <Header.Content>
          Policy Type Configuration
          <Header.Subheader>
            {providerName ? `Configure policy types for ${providerName}` : 'Configure policy types for the selected provider'}
          </Header.Subheader>
        </Header.Content>
      </Header>

      <PolicyTypeConfigSection
        brokerageId={brokerageId!}
        selectedProviderId={providerId}
      />
    </Container>
  );
}

export default BrokerageProviderPolicyTypesPage;
